export const prettyScopeNames = {
	'agents--all:write': 'update any agents profiles configuration',
	'agents--my:write': 'update my profile configuration',
	'agents-bot--all:read': 'read any bot agents configuration',
	'agents-bot--all:write': 'delete any bot agents configuration',
	'agents-bot--my:read': 'read my bot agents configuration',
	'agents-bot--my:write': 'add and update bot agents configuration',
	agents_read: 'read agents list',
	// archives_read: 'read chat archives',
	'auto_chat_scopes:read': 'read auto chat scopes configuration',
	'auto_chat_scopes:write': 'add auto chat scopes configuration',
	// banlist_read: 'read banned customers list',
	// banlist_write: 'manage banned customers',
	// buttons_manage: 'configure chat buttons',
	// canned_responses_read: 'read canned responses list',
	// canned_responses_write: 'add, update and delete canned responses',
	'chats--all:read': 'read any chats',
	'chats--my:read': 'read my chats',
	'chats.conversation--all:write': 'update any chats contents',
	'chats.conversation--my:write': 'update my chats contents',
	'chats.meta--all:write': 'update any chats metadata',
	'chats.meta--my:write': 'update my chats metadata',
	// chat_logos_manage: 'change chat window logo',
	'customers:read': 'read customers',
	'customers:write': 'add and update customers',
	'customers.ban:write': 'ban customers',
	'customers.identity--manage': 'manage customers identities',
	// domain_manage: 'manage trusted domains',
	// eye_catcher_manage: 'add, update and delete eye catchers',
	// forms_manage: 'add, update and delete offline forms',
	// goals_read: 'read goals list',
	// goals_write: 'add, update and delete goals',
	// greetings_read: 'read greetings list',
	// greetings_write: 'add, update and delete greetings',
	// groups_read: 'read groups list',
	// groups_write: 'add, update and delete groups',
	// integrations_read: 'read integrations list',
	// in_app_msg_manage: 'read in-app messages',
	// ledger_read: 'read developer’s financial activity and balance',
	'multicast:write': 'multicast',
	'properties--all:read': 'read any properties configuration',
	'properties--my:read': 'read my properties configuration',
	'properties--my:write': 'add my properties configuration',
	// properties_manage: 'manage license, group and agent properties',
	// reports_read: 'read reports',
	// routing_read: 'read URL rules list',
	// routing_write: 'add, update and delete URL rules',
	// surveys_manage: 'add, update & delete chat surveys',
	// surveys_read: 'read chat surveys',
	// tags_read: 'read tags list',
	// tags_write: 'add, update and delete tags',
	// tickets_read: 'read tickets list',
	// tickets_write: 'create and update tickets',
	// visitors_read: 'read visitors list',
	'webhooks--all:read': 'read any webhooks configuration',
	'webhooks--all:write': 'delete any webhooks configuration',
	'webhooks--my:read': 'read my webhooks configuration',
	'webhooks--my:write': 'add and delete my webhooks configuration'
	// webhooks_manage: 'add, update and delete webhooks'

	// 'chats--all:read': 'Read access for all license chats',
	// 'chats--chat_scopes:read':
	// 	'Read access for the chats with chat scopes matching me',
	// 'chats--my:read': 'Read access for chats I belongs to',
	// 'chats.conversation--chat_scopes:write':
	// 	'Write access for conversation data of chats with chat scopes matching me',
	// 'chats.conversation--my:write':
	// 	'Write access for conversation data of chats I belong to',
	// 'chats.meta--chat_scopes:write':
	// 	'Write access for meta data of chats with chat scopes matching me',
	// 'chats.meta--my:write': 'write access for meta data of chats I belong to',
	// 'customers.ban:write': 'Access for banning customers',
	// 'customers.identity--manage': 'Access for use a customer identity',
	// 'multicast:write': 'Access for multicast data to agents or customers',
	// 'agents--my:write': 'Write access for my agent data',
	// 'agents--all:write': 'Write access for all agents data',
	// 'auto_chat_scopes:read': 'Read access for auto chat scopes configuration',
	// 'auto_chat_scopes:write': 'Write access for auto chat scopes configuration',
	// 'properties--my:read':
	// 	'Read access for properties validator configuration (my namespace)',
	// 'properties--my:write':
	// 	'Write access for properties validator configuration (my namespace)',
	// 'properties--all:read':
	// 	'Read access for properties validator configuration (all license)',
	// 'properties--all:write':
	// 	'Write access for properties validator configuration (all license)',
	// 'webhooks--my:read': 'Read access for webhooks configuration (my webhooks)',
	// 'webhooks--my:write': 'Write access for webhooks configuration',
	// 'webhooks--all:read': 'Read access for webhooks configuration (all license)'
	// 'webhooks--all:write':
	// 	'write access for webhooks configuration (all license, for deletion only)'
	// 'chats.conversation-bot--my:write': 'chats.conversation-bot--my:write',
	// 'agents-bot--all:read': 'agents-bot--all:read',
	// 'agents-bot--my:read': 'agents-bot--my:read',
	// 'agents-bot--all:write': 'agents-bot--all:write',
	// 'agents-bot--my:write': 'agents-bot--my:write'

	// archives_read: 'read chat archives',
	// archives_write: 'chat with your customers',
	// banlist_read: 'read banned customers list',
	// banlist_write: 'manage banned customers',
	// buttons_manage: 'configure chat buttons',
	// canned_responses_read: 'read canned responses list',
	// canned_responses_write: 'add, update and delete canneds',
	// chat_logos_manage: 'change chat window logo',
	// domain_manage: 'manage trusted domains',
	// eye_catcher_manage: 'add, update and delete eye catchers',
	// forms_manage: 'add, update and delete offline forms',
	// goals_read: 'read goals list',
	// goals_write: 'add, update and delete goals',
	// greetings_read: 'read greetings list',
	// greetings_write: 'add, update and delete greetings',
	// groups_read: 'read groups list',
	// groups_write: 'add, update and delete groups',
	// in_app_msg_manage: 'read in-app messages',
	// properties_manage: 'manage license, group and agent properties',
	// reports_read: 'read reports',
	// routing_read: 'read URL rules list',
	// routing_write: 'add, update and delete URL rules',
	// surveys_read: 'read chat surveys',
	// surveys_manage: 'add, update & delete chat surveys',
	// tickets_read: 'read tickets list',
	// tickets_write: 'create and update tickets',
	// tags_read: 'read tags list',
	// tags_write: 'add, update and delete tags',
	// webhooks_manage: 'add, update and delete webhooks',
	// visitors_read: 'read visitors list'
	// email_read is not an actual scope
	// but it's always displayed since all apps
	// will have access to developer's email address
	// email_read: 'see your email address'
}



// WEBPACK FOOTER //
// ./src/containers/Forms/prettyScopes.js